import React, { useEffect } from "react";
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';

// reactstrap components
import { Row, Col, FormGroup, Input, Button, Card, CardBody } from "reactstrap";

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// helpers
import { formateDate } from "helpers/formats";

// services
import { showMessage } from "services/message.js";
import { api_GET, api_POST } from "services/api_service.js";
import { formateDateApi } from "helpers/formats";
import { useAuth } from "context/auth";


export default function ExportacaoLauda() {
    const { setLoading } = useAuth();

    const { register, getValues, errors } = useForm({ mode: "onBlur" });

    const [list_table, set_list_table] = React.useState([]);

    const handleExport = (rowData) => {
        setLoading(true);
        api_GET('lauda/' + rowData.laudaDiarioOficial_Id)
            .then(result => {
                const element = document.createElement("a");
                const file = new Blob([result.data],
                    { type: 'text/plain;charset=utf-8' });
                element.href = URL.createObjectURL(file);
                element.download = "Lauda.txt";
                document.body.appendChild(element);
                element.click();
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const loadList = () => {
        let data = getValues();

        if (data.dataInicio == "" || data.dataFim == "") {
            showMessage("Aviso", "Preencha os campos de data!", 'error', null);
            return;
        }

        setLoading(true);
        let json_filter = {
            inicio: formateDateApi(data.dataInicio),
            fim: formateDateApi(data.dataFim)
        }
        api_POST('lauda/ByPeriodo', json_filter)
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    return (
        <>
            <div className="content">
                <Card className="card-stats">
                    <CardBody>
                        <Row>
                            <Col md="3">
                                <FormGroup>
                                    <b><label>Início</label></b>
                                    <Input type="date" name="dataInicio" innerRef={register({ required: true })} />
                                    {errors.dataInicio && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <b><label>Fim</label></b>
                                    <Input type="date" name="dataFim" innerRef={register({ required: true })} />
                                    {errors.dataFim && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                            </Col>
                            <Col>
                                <Button color="success" className="btn-mobile" type="button" onClick={loadList}><i className="fas fa-search"></i> Pesquisar</Button>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <MaterialTable style={{ minHeight: "auto" }}
                                    title=""
                                    columns={[
                                        { title: 'Data Lauda', field: 'dataPublicacao', render: (rowData) => formateDate(rowData.dataPublicacao) },
                                        { title: 'Enquadramento', field: 'enquadramento.descricao' },
                                        { title: 'Total Registros', field: 'requerimentoLaudaDiarioOficial', render: (rowData) => rowData.requerimentoLaudaDiarioOficial.length, type: 'numeric', cellStyle: { textAlign: "right" } },
                                    ]}
                                    data={list_table}
                                    isLoading={false}
                                    actions={[
                                        {
                                            icon: 'download',
                                            tooltip: 'Exportar Registro',
                                            onClick: (event, rowData) => handleExport(rowData)
                                        }
                                    ]}
                                    localization={table_translate}
                                    options={table_style}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        </>
    );
}